export default __webpack_public_path__ + "static/media/build_my_biz_icon.0a6398b6.svg";